import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DietaryConsiderationsFormModule } from 'ag-common-svc/lib/components/agent-editor/components/dietary-considerations-form/dietary-considerations-form.module';
import { RelationshipTypeSelectBoxModule } from 'ag-common-svc/lib/components/relationship-type-select-box/relationship-type-select-box.module';
import { SelectAssociationModule } from 'ag-common-svc/lib/components/select-association/select-association.module';
import { ModalWindowModule, StatusActivityModule } from 'ag-common-svc/public-api';
import { SharedModule } from 'ag-common-svc/shared/shared.module';
import { ConferencesPipesModule } from '../../../pipes/conferences-pipes.module';
import { AttendeeNoteModalModule } from '../attendee-note-modal/attendee-note-modal.module';
import { AttendeeGuestModalComponent } from './attendee-guest-modal/attendee-guest-modal.component';
import { AttendeeGuestModalService } from './attendee-guest-modal/attendee-guest-modal.service';
import { AttendeeGuestsComponent } from './attendee-guests.component';
import { AttendeeGuestsService } from './attendee-guests.service';
import { BatchOperationsService } from 'ag-common-svc/lib/dao/batch-firestore.service';
import { DxLoadPanelModule, DxValidatorModule } from 'devextreme-angular';
import { TShirtSizesFormModuleDeprecated } from 'ag-common-svc/lib/components/t-shirt-sizes-form-deprecated/t-shirt-sizes-form-module-deprecated.module';
import { TShirtSizesFormModule } from "ag-common-svc/lib/components/t-shirt-sizes-form/t-shirt-sizes-form.module";
import { GuestInfoFieldVisiblePipe } from './attendee-guests-field-visible.pipe';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RelationshipTypeSelectBoxModule,
    StatusActivityModule,
    ModalWindowModule,
    DietaryConsiderationsFormModule,
    SelectAssociationModule,
    AttendeeNoteModalModule,
    ConferencesPipesModule,
    DxLoadPanelModule,
    DxValidatorModule,
    TShirtSizesFormModule,
  ],
  declarations: [AttendeeGuestsComponent, AttendeeGuestModalComponent, GuestInfoFieldVisiblePipe],
  exports: [AttendeeGuestsComponent],
  providers: [AttendeeGuestModalService, AttendeeGuestsService, BatchOperationsService],
})
export class AttendeeGuestsModule {}
